import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['phoneInput', 'emailInput'];

  inputTimer = null;

  connect() {
    this.previewSource = document.querySelector('[data-target-preview-source-base]');
    this.previewSourceBase = this.previewSource.dataset.previewSourceBase;
  }

  setpreviewUrl() {
    clearTimeout(this.inputTimer);
    this.inputTimer = setTimeout(
      (() => {
        let phone_value = encodeURIComponent(this.phoneInputTarget.value);
        let email_value = encodeURIComponent(this.emailInputTarget.value);
        let frame_src = `${this.previewSourceBase}?email=${email_value}&phone=${phone_value}`;
        this.previewSource.setAttribute('src', frame_src);
      }).bind(this),
      400
    );
  }

  submitForm() {
    let rgpdForm = document.querySelector("[data-oqoro-admin--rgpd--droit-oubli-target='form']");
    rgpdForm.submit();
  }
}
